import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import {
  crudRoutes,
  inventoryRoutes,
} from "../../../../router/routesConstants";
import { PickingBoxInterface } from "../../../../redux/interfaces/inventory.interface";

export default function PickingBoxesActionButtons({
  crudData,
}: {
  crudData: PickingBoxInterface;
}) {
  const id = crudData.idCutie;
  const name = crudData.nume;
  const nameQuery = name ? `?numeCutie=${encodeURIComponent(name)}` : "";
  const basePath = `/${inventoryRoutes.inventory}/${inventoryRoutes.pickingBoxStocks}/${id}`;
  return (
    <ActionMenu
      minItemsForMenu={2}
      title={name}
      ariaLabel={`Actiuni pentru cutia ${name || id}`}
      items={[
        {
          id: "edit",
          label: "Editeaza cutia",
          icon: "EDIT",
          tooltip: "Modifica datele cutiei de picking.",
          navigate: `${basePath}/${crudRoutes.edit}`,
        },
        {
          id: "history",
          label: "Istoric cutie",
          icon: "SPLIT_LIST",
          tooltip:
            "Deschide istoricul operatiunilor efectuate cu aceasta cutie.",
          navigate: `${basePath}/${inventoryRoutes.pickingBoxHistory}${nameQuery}`,
        },
      ]}
    />
  );
}
